
import styles from "./style.module.css";
import pauseIcon from "../../../assets/images/icons/pause_icon.svg"

export default function RoundedButtonTB({ setPlay, play, setCounterPauses }) {

  console.log("button", play);

  return (
    <>
      <div className={styles.RoundB}>
        <button className={`${styles.RoundedButton} ${!play ? styles.RoundedButtonPlay : ""}`} onClick={() => { if (!play) { setCounterPauses(prev => prev + 1) }; setPlay(old => !old) }}>{play ? <img src={pauseIcon} /> : '▶'}</button>       {/* //TODO: the counter is unneccery?? */}
      </div>
    </>
  );
} 